import { useStyles } from '@signavio/ui';
import { utils, padding } from '../styles';
import { jsx as _jsx } from "react/jsx-runtime";
const Empty = ({
  block = false,
  placeholder = false,
  children
}) => {
  const style = useStyles(defaultStyles, {}, {
    '&block': block,
    '&placeholder': placeholder
  });
  return /*#__PURE__*/_jsx("span", {
    ...style,
    children: children
  });
};
const defaultStyles = theme => {
  return {
    color: utils.textColor(theme.color.mono.light),
    fontStyle: 'italic',
    '&block': {
      display: 'block',
      paddingLeft: padding.normal,
      paddingRight: padding.normal
    },
    '&placeholder': {
      ...utils.ellipsis()
    }
  };
};
export default Empty;